import { CspConfigs } from "components/Integrations/types";
import { integrationOptionProvider } from "components/Integrations/utils/resourcesInstalledUtil";

import { SplunkStackIntegrationInstaller } from "../types";

export const splunkStackResourceInstaller = (
  cspConfigs: Omit<CspConfigs, "self-hosted">
): SplunkStackIntegrationInstaller["iam-write"] => ({
  items: {
    service: {
      options: {
        azure: {
          items: {
            service: {
              optionProvider: integrationOptionProvider("iam-write", [
                {
                  firestoreRef: cspConfigs.azure,
                  component: "function-caller",
                  labelTitle: "Azure Function",
                  keyPrefix: "azure",
                },
              ]),
            },
          },
        },
        aws: {
          items: {
            lambda: {
              optionProvider: integrationOptionProvider("iam-write", [
                {
                  firestoreRef: cspConfigs.aws,
                  component: "function-caller",
                  labelTitle: "AWS Lambda",
                  keyPrefix: "aws",
                },
              ]),
            },
          },
        },
        gcp: {
          items: {
            cloudRun: {
              optionProvider: integrationOptionProvider("iam-write", [
                {
                  firestoreRef: cspConfigs.gcloud,
                  component: "function-caller",
                  labelTitle: "Cloud Run Service",
                  keyPrefix: "gcp",
                },
              ]),
            },
          },
        },
      },
    },
  },
  prerequisiteMessages: async (context) => {
    const provider = integrationOptionProvider("iam-write", [
      {
        firestoreRef: cspConfigs.aws,
        component: "function-caller",
        labelTitle: "AWS",
        keyPrefix: "aws",
      },
      {
        firestoreRef: cspConfigs.gcloud,
        component: "function-caller",
        labelTitle: "GCP",
        keyPrefix: "gcp",
      },
    ]);
    const options = await provider(context);
    if (!options.length)
      return (
        <div>
          Requires installed &quot;AWS or GCP Function Caller&quot; component
        </div>
      );
  },
});
